export const LEG_COLORS = [
  "#1976D2",
  "#D32F2F",
  "#388E3C",
  "#CA8A04",
  "#7B1FA2",
  "#0097A7",
  "#F57C00",
  "#5D4037",
  "#C2185B",
  "#455A64",
];

export function getLegColor(index) {
  return LEG_COLORS[index % LEG_COLORS.length];
}
